export default __webpack_public_path__ + "assets/amigo-logo-35aae291cfff56cb058faf94bee99dfc.svg";